<template>
    <!-- swiper one -->
    <section class="home-swiper-one">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <section class="content-slide-item">
                        <div class="slider-header">
                            <img src="@/assets/webImg/home/swiper1.png" alt="" style="width: 524px; height: 261px;">
                        </div>
                        <p class="slider-title">人事管理</p>
                        <ul class="slider-text">
                            <li>员工档案材料云端储存, 告别纸质档案;</li>
                            <li>在线入职, 组织机构个性定制, 岗位灵活调配;</li>
                            <li>人事信息实时提醒, 法律法规提醒, 规避用工风险;</li>
                        </ul>
                        <button>查看更多</button>
                    </section>
                    <section class="content-slide-item">
                        <div class="slider-header">
                            <img src="@/assets/webImg/home/swiper2.png" alt="" style="width: 524px; height: 261px;">
                        </div>
                        <p class="slider-title">费用报销</p>
                        <ul class="slider-text">
                            <li>移动办公信息同步, 实时报销一键快速审核;</li>
                            <li>报销票据智能自动识别, 报销凭证信息抓取, 准确无误;</li>
                            <li>报销信息同步财务审核流程, 信息提交快速审核, 快速结款;</li>
                        </ul>
                        <button>查看更多</button>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="content-slide-item">
                        <div class="slider-header">
                            <img src="@/assets/webImg/home/swiper1.png" alt="" style="width: 524px; height: 261px;">
                        </div>
                        <p class="slider-title">时间管理</p>
                        <ul class="slider-text">
                            <li>开启随心所欲, 透明开心的考勤管理;</li>
                            <li>支持多种考勤模式, 打卡信息实时收录, 考勤信息不遗漏;</li>
                            <li>打卡日历, 考勤地图, 排班调班等, 考勤信息实时同步精准无误;</li>
                        </ul>
                        <button>查看更多</button>
                    </section>
                    <section class="content-slide-item">
                        <div class="slider-header">
                            <img src="@/assets/webImg/home/swiper2.png" alt="" style="width: 524px; height: 261px;">
                        </div>
                        <p class="slider-title">薪酬核算</p>
                        <ul class="slider-text">
                            <li>告别excel, 再复杂也能算得又快又准;</li>
                            <li>一键核算考勤, 薪酬, 既快又准, 规避政策风险;</li>
                            <li>多维统计分析生成图表, 深度解析评估企业薪酬考勤人力成本;</li>
                        </ul>
                        <button>查看更多</button>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="content-slide-item">
                        <div class="slider-header">
                            <img src="@/assets/webImg/home/swiper1.png" alt="" style="width: 524px; height: 261px;">
                        </div>
                        <p class="slider-title">员工自助</p>
                        <ul class="slider-text">
                            <li>移动办公信息同步, 员工自助打卡, 报销等自主操作;</li>
                            <li>员工可自助查看工资条, 档案, 通讯录等相关信息;</li>
                            <li>流程管理, 自助审批申请, 公司新闻公告信息通知;</li>
                        </ul>
                        <button>查看更多</button>
                    </section>
                </div>
            </div>
            <!-- Add Arrows -->
            <div class="next">
               <el-image style="width: 126px; height: 126px" :src="require(`${'@/assets/webImg/home/arrow_right.png'}`)" fit="cover"></el-image>
            </div>
        </div>
    </section>
</template>

<script>
export default {
	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

    mounted() {
        var mySwiper = new Swiper('.swiper-container', {
            // autoplay: true,         // 可选选项，自动滑动
            // slidesPerView: 1,
            grabCursor: true,       // 小手
            loop: true,             // 循环
            navigation: {
                nextEl: '.next',
            },
        })

    },

    methods: {
    }
}
</script>

<style lang="scss">
.home-swiper-one {
    margin-top: 100px;
    height: 700px;
    position: relative;
    .swiper-container {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
        border-top: 100px solid #ffffff;
        // padding-left: 44px;
        background: #F6F8FA;
        &::before {
            display: inline-block;
            content: '';
            width: 270px;
            height: 100%;
            background: #ffffff;
            border-left: 160px solid #F6F8FA;
        }
        display: flex;
        .content-slide-item {
            margin-top: -100px;
            margin-left: 106px;
            width: 536px;
            .slider-header {
                padding-top: 14px;
                padding-right: 12px;
                width: 100%;
                box-sizing: border-box;
                position: relative;
                &::before {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 167px;
                    height: 126px;
                    border-top: 14px solid #004999;
                    border-right: 12px solid #004999;
                }
            }
            .slider-title {
                margin-top: 10px;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #004999;
            }
            .slider-text {
                margin-top: 50px;
                font-size: 18px;
                line-height: 18px;
                color: #666666;
                li { margin-bottom: 24px; }
                li::before {
                    display: inline-block;
                    position: relative;
                    top: -2px;
                    content: '';
                    width: 4px;
                    height: 4px;
                    border-radius: 100%;
                    background: #414141;
                    margin-right: 20px;
                }
            }

        }
    }
    .next {
        position: absolute;
        z-index: 999;
        top: 300px;
        left: 96px;
        height: 100%;
        display: flex;
        justify-content: center;
    }

    button {
        display: block;
        width: 172px;
        height: 56px;
        background: #004999;
        margin-top: 70px;
        color: white;
        font-size: 24px;
        line-height: 56px;
        border: none;
        outline: none;
    }
}

</style>
